import React, { useEffect, useState } from "react";
import { GraduationCap, Clock, CheckCircle2, BookOpen } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Label, EmptyState } from "../../components/common";
import { Button } from "../../components/ui/button";

export default function Training() {
  const { user } = useAuth();
  const isEmployee = user.role === "employee";
  const [modules, setModules] = useState([]);
  const [assignments, setAssignments] = useState([]);

  const load = () => {
    api.get("/training/modules").then((r) => setModules(r.data)).catch(() => {});
    api.get("/training/assignments").then((r) => setAssignments(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const complete = async (a) => {
    try { await api.post(`/training/assignments/${a.id}/complete`); toast.success("Training completed — badge earned!"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-6">
      <div><Label>Improvement</Label><h1 className="font-head text-2xl font-bold text-slate-900 sm:text-3xl">{isEmployee ? "My Training" : "Training"}</h1></div>

      {isEmployee && (
        <div>
          <Label>Assigned to me</Label>
          {assignments.length === 0 ? (
            <div className="mt-2"><EmptyState icon={GraduationCap} title="No assignments yet" hint="Training assigned to you will appear here." /></div>
          ) : (
            <div className="mt-3 grid gap-3 sm:grid-cols-2">
              {assignments.map((a) => (
                <div key={a.id} className="rounded-xl border border-slate-200 bg-white p-5" data-testid={`assignment-${a.id}`}>
                  <div className="flex items-start justify-between">
                    <div>
                      <p className="font-head font-semibold text-slate-900">{a.module?.title}</p>
                      <p className="mt-1 flex items-center gap-1 text-xs text-slate-400"><Clock className="h-3.5 w-3.5" />{a.module?.duration_min} min</p>
                    </div>
                    {a.status === "completed"
                      ? <span className="flex items-center gap-1 text-sm font-bold text-emerald-600"><CheckCircle2 className="h-4 w-4" />Done</span>
                      : <Button size="sm" onClick={() => complete(a)} data-testid={`complete-${a.id}`} className="bg-[#4338CA] hover:bg-[#3730A3]">Complete</Button>}
                  </div>
                  <p className="mt-2 text-sm text-slate-500">{a.module?.description}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <div>
        <Label>Training Catalogue</Label>
        <div className="mt-3 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {modules.map((m) => (
            <div key={m.id} className="rounded-xl border border-slate-200 bg-white p-5" data-testid={`module-${m.id}`}>
              <BookOpen className="h-5 w-5 text-indigo-500" />
              <p className="mt-2 font-head font-semibold text-slate-900">{m.title}</p>
              <p className="mt-1 flex items-center gap-1 text-xs text-slate-400"><Clock className="h-3.5 w-3.5" />{m.duration_min} min</p>
              <p className="mt-2 text-sm text-slate-500">{m.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
